import React from 'react'
import {useIntl} from 'react-intl'
import {Link, useNavigate} from 'react-router-dom'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import BlueImage from '../images/blue-bg.png'

export default function StartupFullWidthCard({startupDetails}: any) {
  console.log(startupDetails, ' startup')

  const founders = startupDetails?.company?.founders?.split(',').slice(0, 2) || []
  const {formatMessage} = useIntl()
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(`startup-details/${startupDetails?.startupShowcaseId}`) // Navigates to the details page using the ID
  }

  return (
    <div className='mb-4 rounded-2'>
      <div className='p-0'>
        <div className='d-flex flex-column justify-content-between flex-md-row align-items-center'>
          <div className='documents-card-v2 flex-grow-1 bg-white w-100'>
            <div className={`d-flex flex-column flex-md-row justify-self-start cardLayout`}>
              <Link to={''} className='doc-image'>
                <img src={BlueImage} alt='documents thumbnail' className={`d-flex `} />
              </Link>
              <div className='d-flex flex-column w-100 p-4 justify-content-between'>
                <div className='d-flex flex-column'>
                  <div className='d-flex justify-content-between align-items-center mb-4'>
                    <div className=''>
                      <div className=''>
                        <span
                          className='px-4 py-1 font-size-14 mb-4'
                          style={{borderRadius: '80px', border: '1px solid #CFE0FA'}}
                        >
                          {startupDetails?.company?.industryName}
                        </span>
                      </div>
                      <h5 className='font-size-16 d-flex align-items-center gap-2 mt-6'>
                        {startupDetails?.company?.name}
                      </h5>
                      <p className='font-size-13 text-muted mb-0'>
                        {' '}
                        {startupDetails?.company?.shortDescription}
                      </p>
                    </div>
                    <button
                      className='btn border border-primary rounded d-flex flex-md-column gap-2 gap-md-0 align-items-center px-6 py-3'
                      style={{alignSelf: 'baseline', background: '#F0F4FF'}}
                    >
                      <span className='text-primary font-size-10'>▲</span>
                      <span className='fw-bold text-primary font-size-14'>
                        {startupDetails?.voteCount}
                      </span>
                      <span className='text-primary font-size-10'>Vote</span>
                    </button>
                  </div>
                  <p className='font-size-13 w-md-75'>
                    {startupDetails?.company?.description?.length > 30
                      ? `${startupDetails.company.description.substring(0, 40)}...`
                      : startupDetails?.company?.description}
                  </p>
                  <div className='d-md-flex justify-content-between'>
                    {founders &&
                      founders.map((founder: any) => (
                        <div className='d-flex align-items-center gap-1 mb-4 mb-md-auto mt-2 mt-md-auto'>
                          <DisplayImage
                            className='rounded-circle'
                            height={32}
                            width={32}
                            imgName=''
                            alt='profile-pic'
                          />
                          <div className='me-4'>
                            <p className='font-size-12 fw-semibold text-dark m-0'>{founder}</p>
                            <p className='font-size-12 text-muted m-0'>Founder</p>
                          </div>
                        </div>
                      ))}

                    <div className='d-flex justify-content-end'>
                      <button onClick={handleNavigate} className='btn btn-primary cta-documents'>
                        {formatMessage({id: 'Know More'})}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
